import {
    Menu,
    MenuItem,
} from '@mui/material';
import React from 'react';
interface DownloadReportMenuDialogProps {
    open: boolean;
    mysteryTestId?: string;
    mysteryTestSubmitted?: boolean;
    companyId?: string;
    version?: number;
    onClose: () => void;
    anchorEl: null | HTMLElement;
}

const openMysteryTestReport = (mysteryTestId: string) => {
    // @todo cleanup and security
    window.open(window.location.origin + '/api/reports/mystery-test/' + mysteryTestId);
};

const openContract = (companyId: string, version?: number) => {
    const versionSuffix = version ? `/v/${version}` : '';
    window.open(window.location.origin + '/api/contract/' + companyId + versionSuffix);
};

const DownloadReportMenu = (props: DownloadReportMenuDialogProps) => {

    return (
        <Menu
            anchorEl={props.anchorEl}
            open={props.open}
            onClose={props.onClose}
        >
            {props.mysteryTestSubmitted && props.mysteryTestId && (
                <>
                    <MenuItem
                        onClick={() => {
                            openMysteryTestReport(
                                props.mysteryTestId!,
                            );
                            props.onClose();
                        }}
                    >
                        Admin-Report
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            openMysteryTestReport(
                                props.mysteryTestId! + '_company',
                            );
                            props.onClose();
                        }}
                    >
                        Unternehmensreport
                    </MenuItem>
                </>
            )}
            <MenuItem
                onClick={() => {
                    openContract(props.companyId + '', props.version);
                    props.onClose();
                }}
            >
                Buchungsvertrag{props.version ? ` (v${props.version})` : ''}
            </MenuItem>
            <MenuItem
                onClick={() => {
                    openContract(props.companyId + '_voucher', props.version);
                    props.onClose();
                }}
            >
                Gutschein{props.version ? ` (v${props.version})` : ''}
            </MenuItem>
        </Menu>
    );
};

export default DownloadReportMenu;
